/**
 * @generated SignedSource<<3e38b14300118edf35f890883ab7cfa0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductKind = "CONSUMABLE" | "ITEM" | "KIT" | "%future added value";
export type CreateProductInput = {
  category: string;
  clientMutationId?: string | null | undefined;
  dailyRate?: number | null | undefined;
  forProductId?: string | null | undefined;
  kind: ProductKind;
  make?: string | null | undefined;
  model?: string | null | undefined;
  name?: string | null | undefined;
  notes?: string | null | undefined;
  packSize?: string | null | undefined;
  price?: number | null | undefined;
  properties?: any | null | undefined;
  quantityOnHand?: number | null | undefined;
  rentable?: boolean | null | undefined;
  reorderLevel?: number | null | undefined;
  slug?: string | null | undefined;
  unit?: string | null | undefined;
};
export type OpsProductsPageCreateMutation$variables = {
  input: CreateProductInput;
};
export type OpsProductsPageCreateMutation$data = {
  readonly createProduct: {
    readonly product: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsProductsPageCreateMutation = {
  response: OpsProductsPageCreateMutation$data;
  variables: OpsProductsPageCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateProductPayload",
    "kind": "LinkedField",
    "name": "createProduct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "product",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsProductsPageCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsProductsPageCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1e29e0e9bcd0da59d6b1bac56eb2727f",
    "id": null,
    "metadata": {},
    "name": "OpsProductsPageCreateMutation",
    "operationKind": "mutation",
    "text": "mutation OpsProductsPageCreateMutation(\n  $input: CreateProductInput!\n) {\n  createProduct(input: $input) {\n    product {\n      id\n    }\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "806e603bef5d00e62b99b452ddbfd6c8";

export default node;
